import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { api } from '../api/endpoints';
import { LoadingPill } from '../components/LoadingPill';
import { SampleDataView } from '../features/sample/SampleDataView';

function SampleDataPage() {
  const manifest = useQuery({ queryKey: ['sample-manifest'], queryFn: api.sampleManifest });
  return manifest.data ? <SampleDataView data={manifest.data} /> : <LoadingPill label="Loading…" />;
}

export const Route = createFileRoute('/sample-data')({ component: SampleDataPage });
